import React from "react";

import { useLocation, Navigate } from "react-router-dom";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { selectCurrentUserIsInternal } from "Reducers/app/selectors";
import { selectAdminAgentUrl } from "Reducers/serviceProcesses/serviceProcesses.selectors";
import { useAppSelector } from "Store/hooks";

export type ServiceProcessGuardProps = {
  children: React.ReactNode;
};

export const ServiceProcessGuard = ({ children }: ServiceProcessGuardProps) => {
  const url = useLocation().pathname;
  const adminAgentUrl = useSelectorWithUrlParams(selectAdminAgentUrl);
  const isInternalUser = useAppSelector(selectCurrentUserIsInternal);
  const hasAdminAgentUrl = !!adminAgentUrl;

  if (!hasAdminAgentUrl || !isInternalUser) {
    return <Navigate to={url} />;
  }

  return <>{children}</>;
};
